import Lenis from 'lenis';
import 'lenis/dist/lenis.css'

const lenis = new Lenis({autoRaf: true});

document.documentElement.addEventListener('toggle-receiver:toggled', () => queueMicrotask(() => lenis.resize()));
document.documentElement.addEventListener('turbo:before-visit', () => lenis.stop());
document.documentElement.addEventListener('turbo:before-render', () => lenis.start());
document.documentElement.addEventListener('turbo:before-frame-render', () => lenis.start());

const observer = new ResizeObserver(() => lenis.resize());

const init = () => {
    observer.disconnect();
    observer.observe(document.body);
};

document.documentElement.addEventListener('turbo:load', init);

if ('loading' === document.readyState) {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
